import { staticPath } from '@libraries/common/staticPath';

// 크리에이터 시작하기 (온보딩)
export const startCreator = '/start';

// 서비스 소개
export const serviceIntroduction = staticPath('docs/steadio_intro.pdf');

// 공지사항
export const notice =
  'https://tumcorp.notion.site/17e0badf6fcb4165a39d50c184714071?v=117b1d7b1ba849b6bf3ea1fb0752dcda';

// 헬프 센터
export const helpCenter = 'https://steadio.zendesk.com/hc/ko';

// 크리에이터 가이드
export const creatorGuide =
  'https://tumcorp.notion.site/3636011a51d546739cae46946c4f97fc';

// 서비스 이용 약관
export const termsOfUse =
  'https://steadio.zendesk.com/hc/ko/articles/6674963349145';

// 개인정보 수집 및 이용
export const privacyCollectionAndUsagePolicy =
  'https://steadio.zendesk.com/hc/ko/articles/7779669912473';

// 개인정보 처리방침
export const privacyPolicy =
  'https://steadio.zendesk.com/hc/ko/articles/6674965622809';

// 개인정보 제3자 제공 동의
export const thirdPartyPrivacyPolicy =
  'https://steadio.zendesk.com/hc/ko/articles/7780125852697';

// 커뮤니티 운영방침
export const communityPolicy =
  'https://steadio.zendesk.com/hc/ko/articles/6674994738841';

// 스테디오에 문의
export const contactUs = 'https://steadio.zendesk.com/hc/ko/requests/new';

export const kakaotalk = 'https://pf.kakao.com/_Kzxamb';

export const instagram = 'https://www.instagram.com/steadio.official';

export const twitter = 'https://twitter.com/steadio_co';

export const operatingHours = '평일 10:00~17:00 (13:00~15:00 제외)';
